export default __webpack_public_path__ + "img/45f142c21631b248d9ac90445f935af7.svg";